<nav class="main-nav">
  <button class="hamburger-btn" aria-label="Toggle menu" [attr.aria-expanded]="showMobileMenu" (click)="toggleMobileMenu()">
    <lucide-icon [name]="MenuIcon" size="20"></lucide-icon>
  </button>
  <div class="nav-logo" role="button" tabindex="0" (click)="goToLogoDestination()" (keydown.enter)="goToLogoDestination()" (keydown.space)="goToLogoDestination()">
    <img src="assets/logo_black.png" style="width: 120px;" alt="The Floor Theory Logo">
  </div>
  <div class="nav-links-wrapper">
    <div class="nav-links">
      <ng-container *ngIf="(userProfile$ | async)?.role === 'admin'; else publicDesktopLinks">
        <a *ngFor="let link of adminNavLinks"
           [routerLink]="link.route"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: !!link.exact }">
          {{ link.label }}
        </a>
      </ng-container>
      <ng-template #publicDesktopLinks>
        <a *ngFor="let link of publicNavLinks"
           [routerLink]="link.route"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: !!link.exact }">
          {{ link.label }}
        </a>
        <a *ngIf="(userProfile$ | async)?.role != 'admin'" routerLink="/contact" routerLinkActive="active">Contact Us</a>
      </ng-template>
      <a *ngIf="!(userProfile$ | async)" routerLink="/signin" routerLinkActive="active" class="btn-signin-nav">Sign In</a>
      <div *ngIf="userProfile$ | async as profile" class="profile-dropdown-container">
        <div class="profile-trigger" routerLink="/profile">
          <img *ngIf="profile.photoURL" [src]="profile.photoURL" [alt]="profile.displayName || 'User'" class="profile-avatar">
          <div *ngIf="!profile.photoURL" class="profile-placeholder">
            <lucide-icon [name]="UserIcon" size="20"></lucide-icon>
          </div>
        </div>
        <div class="dropdown-menu">
          <div class="dropdown-header">
            <span class="user-name">{{ profile.displayName || profile.fullName || 'User' }}</span>
            <span class="user-email">{{ profile.email }}</span>
          </div>
          <div class="dropdown-divider"></div>
          <a *ngIf="profile.role !== 'admin'" routerLink="/my-bookings" class="dropdown-item">
            <lucide-icon [name]="BookingIcon" size="16"></lucide-icon>
            My Booking
          </a>
          <a *ngIf="profile.role !== 'admin'" routerLink="/profile" class="dropdown-item">
            <lucide-icon [name]="UserIcon" size="16"></lucide-icon>
            My Profile
          </a>
          <button (click)="logout()" class="dropdown-item logout-btn">
            <lucide-icon [name]="LogOutIcon" size="16"></lucide-icon>
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- font switcher removed — app now uses Outpost bold globally -->

</nav>

<!-- Mobile menu overlay moved outside of nav to avoid stacking context issues -->
<div class="mobile-menu" [class.open]="showMobileMenu" role="dialog" aria-modal="true" *ngIf="showMobileMenu">
  <div class="mobile-menu-panel" role="presentation">
    <div class="mobile-panel-header">
      <button class="mobile-close" aria-label="Close menu" (click)="closeMobileMenu()">
        <lucide-icon [name]="CloseIcon" size="22"></lucide-icon>
      </button>
      <div class="mobile-panel-logo" role="button" tabindex="0" (click)="goToLogoDestination(); closeMobileMenu()" (keydown.enter)="goToLogoDestination(); closeMobileMenu()" (keydown.space)="goToLogoDestination(); closeMobileMenu()">
        <img src="assets/logo_black.png" alt="The Floor Theory" />
      </div>
    </div>

    <nav class="mobile-nav-links" aria-label="Mobile Navigation">
      <ng-container *ngIf="(userProfile$ | async)?.role === 'admin'; else publicMobileLinks">
        <a *ngFor="let link of adminNavLinks"
           [routerLink]="link.route"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: !!link.exact }"
           (click)="closeMobileMenu()">
          {{ link.label }}
        </a>
      </ng-container>
      <ng-template #publicMobileLinks>
        <a *ngFor="let link of publicNavLinks"
           [routerLink]="link.route"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: !!link.exact }"
           (click)="closeMobileMenu()">
          {{ link.label }}
        </a>
        <a *ngIf="(userProfile$ | async)?.role != 'admin'" routerLink="/contact" routerLinkActive="active" (click)="closeMobileMenu()">Contact Us</a>
      </ng-template>
      <a *ngIf="!(userProfile$ | async)" routerLink="/signin" routerLinkActive="active" (click)="closeMobileMenu()" class="mobile-signin-link">Sign In →</a>
      <ng-container *ngIf="userProfile$ | async as profile">
        <a *ngIf="profile.role !== 'admin'" routerLink="/my-bookings" routerLinkActive="active" (click)="closeMobileMenu()">My Bookings</a>
        <a *ngIf="profile.role !== 'admin'" routerLink="/profile" routerLinkActive="active" (click)="closeMobileMenu()">My Profile</a>
        <a (click)="logout()" class="mobile-logout-link">Logout</a>
      </ng-container>
    </nav>

    <div class="mobile-panel-footer">
      <div class="mobile-social">
        <a href="https://www.instagram.com/thefloortheory_?igsh=emN5OXNkdTk0ZTRr&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><lucide-icon [name]="InstagramIcon" size="18"></lucide-icon></a>
        <a href="https://www.facebook.com/share/1dCVxYTQNm/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><lucide-icon [name]="FacebookIcon" size="18"></lucide-icon></a>
        <a href="https://www.youtube.com/@TheFloorTheory" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><lucide-icon [name]="YoutubeIcon" size="18"></lucide-icon></a>
        <a href="https://wa.me/917358790656" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><lucide-icon [name]="WhatsAppIcon" size="18"></lucide-icon></a>
        <!-- <a href="#" aria-label="Twitter"><lucide-icon [name]="TwitterIcon" size="18"></lucide-icon></a> -->
      </div>
    </div>
  </div>
  <!-- transparent full-screen click catcher so clicking outside the panel closes the menu -->
  <div class="mobile-menu-click-catcher" (click)="closeMobileMenu()" aria-hidden="true"></div>
</div>
